import { FlexboxVertical } from '../../styles/Layouts';
import styled, { css, keyframes } from 'styled-components';
import { getThemeColor, ThemeColorKey } from '../../styles/Theme';
import { FC } from 'react';
import { UIComponentProps } from '../../styles/UIComponentProps';
import { TEXTS } from '../../styles/FontStyles';

const Wrapper = styled(FlexboxVertical)<ILoadingSpinnerProps>`
  color: ${({ color = 'purple' }) => getThemeColor(color as ThemeColorKey) || color};

  ${({ inline = false }) => !inline && css`
    min-height: 11.25rem;
  `};
  
  ${({ inline = false }) => inline && css`
    height: 0;
    overflow: visible;
    justify-content: center;
  `};
`;

const SpinningAnimation = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div<ILoadingSpinnerProps>`
  width: ${({ inline = false, size }) => size || (inline ? '1.5rem' : '3.5rem')};
  height: ${({ inline = false, size }) => size || (inline ? '1.5rem' : '3.5rem')};
  border-radius: 50%;
  flex-shrink: 0;
  margin: auto;

  border: 3px solid transparent;
  border-bottom-color: currentColor;

  animation: ${SpinningAnimation} 1.5s ease infinite forwards;
`;

const TextWrapper = styled(FlexboxVertical)`
  ${TEXTS.headline5};
  margin: 0 auto auto;
`;

interface ILoadingSpinnerProps {
  inline?: boolean;
  size?: string;
  color?: string | ThemeColorKey;
}

export const LoadingSpinner: FC<ILoadingSpinnerProps & UIComponentProps> = (props) => {
  const {
    inline,
    size,
    children,
  } = props;

  return (
    <Wrapper {...props}>
      <Spinner inline={inline} size={size} />
      {
        children &&
        <TextWrapper>{children}</TextWrapper>
      }
    </Wrapper>
  );
};